export const domainUrl = process.env.REACT_APP_FRONTEND_URL + '/';

export const apiUrl = process.env.REACT_APP_API_URL + '/';

export const screenSizes = {
    lg: 1200,
    md: 992,
    sm: 768,
    xs: 480
};

export const editorModules = {
    toolbar: [
        [{ 'font': [] }],
        [{ 'size': [] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'align': [] }],
        [{ 'script': 'sub' }, { 'script': 'super' }],
        ['link', 'image'],
        ['clean']
    ],
};

export const editorFormats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent', 'align', 'color', 'background', 'script',
    'link', 'image', 'undoc', 'redoc'
];


export const publicPaths = ['/', '/onboard'];

export const systemEmailVars = {
    AssignedCoachNotification: [
        {
            value: '{{name}}',
            title: 'Group Name'
        },
        {
            value: '{{link}}',
            title: 'Link'
        },
    ],
    // AssignmentReminderNotification: [ 
    //     {
    //         value: '{{name}}',
    //         title: 'Group Name'
    //     },
    //     {
    //         value: '{{link}}',
    //         title: 'Link'
    //     },
    // ],
    // AssignmentUserNotification: [ 
    //     {
    //         value: '{{name}}',
    //         title: 'Group Name'
    //     },
    //     {
    //         value: '{{link}}',
    //         title: 'Link'
    //     },
    // ],
    NewFileShared: [
        {
            value: '{{name}}',
            title: 'User\'s Name'
        },
        {
            value: '{{link}}',
            title: 'File URL'
        },
    ],
    NewPrimaryAgendaShared: [
        {
            value: '{{name}}',
            title: 'User\'s Name'
        },
        {
            value: '{{link}}',
            title: 'PDF Link'
        },
    ],
    NewSecondaryAgendaShared: [
        {
            value: '{{name}}',
            title: 'User\'s Name'
        },
        {
            value: '{{link}}',
            title: 'PDF Link'
        },
    ],
    NewSurveyReminderReceived: [
        {
            value: '{{name}}',
            title: 'Sender\'s Name'
        },
        {
            value: '{{link}}',
            title: 'Link'
        },
    ],
    PasswordResetNotification: [
        {
            value: '{{link}}',
            title: 'Reset Link'
        },
    ],
    ReminderCreated: [
        {
            value: '{{name}}',
            title: 'Name'
        },
        {
            value: '{{notes}}',
            title: 'Notes'
        },
        {
            value: '{{link}}',
            title: 'Link'
        },
    ],
    SendReminder: [
        {
            value: '{{name}}',
            title: 'Name'
        },
        {
            value: '{{notes}}',
            title: 'Notes'
        },
        {
            value: '{{link}}',
            title: 'Link'
        },
    ],
    SurveyReminderNotification: [
        {
            value: '{{name}}',
            title: 'Sender\'s Name'
        },
        {
            value: '{{link}}',
            title: 'Link'
        },
    ],
};

export const groupInviteVars = [
    {
        value: '{{groupName}}',
        title: 'Group Name'
    },
    {
        value: '{{groupKey}}',
        title: 'Access Key'
    },
    {
        value: '{{profName}}',
        title: 'Professor\'s Full Name'
    },
    {
        value: '{{profEmail}}',
        title: 'Professor\'s Email'
    },
    {
        value: '{{userFirstName}}',
        title: 'Executive\'s First Name'
    },
    {
        value: '{{userLastName}}',
        title: 'Executive\'s Last Name'
    },
    {
        value: '{{userEmail}}',
        title: 'Executive\'s Email'
    },
];

export const groupWelcomeEmailVars = [
    {
        value: '{{groupName}}',
        title: 'Group Name'
    },
    {
        value: '{{userName}}',
        title: 'Executive\'s Full Name'
    },
    {
        value: '{{userEmail}}',
        title: 'Executive\'s Email'
    },
];

export const surveyInvitationVars = [
    {
        value: '{{surveyTitle}}',
        title: 'Survey Title',
    },
    {
        value: '{{surveyLink}}',
        title: 'Submission Link',
    },
    {
        value: '{{surveyStart}}',
        title: 'Survey Start Date',
    },
    {
        value: '{{surveyEnd}}',
        title: 'Survey End Date',
    },
    {
        value: '{{firstName}}',
        title: 'User First Name',
    },
    {
        value: '{{lastName}}',
        title: 'User Last Name',
    },
    {
        value: '{{userFirstName}}',
        title: 'Executive\'s First Name',
    },
    {
        value: '{{userLastName}}',
        title: 'Executive\'s Last Name',
    },
    {
        value: '{{userEmail}}',
        title: 'Executive\'s Email',
    },
];

export const surveyIntroVars = [
    {
        value: '{{firstName}}',
        title: 'Executive\'s First Name'
    },
    {
        value: '{{lastName}}',
        title: 'Executive\'s Last Name'
    },
    {
        value: '{{questionsLength}}',
        title: 'Number of questions'
    },
];

export const ASSIGNMENT_RESPONSE_TYPES = {
    VIDEO: 1,
    PDF: 2,
    BOTH: 3
};

export const roles = [{ type: 2, name: 'Admin' }, { type: 3, name: 'Coach' }, { type: 1, name: 'Participant' }];

//Template Types
export const GROUP_INVITATION_TEMPLATE = 1;
export const GROUP_WELCOME_EMAIL_TEMPLATE = 2;
export const GROUP_WELCOME_TEXT_TEMPLATE = 3;
export const SURVEY_INTRODUCTORY_TEMPLATE = 4;
export const SURVEY_REPORT_INTRO_TEMPLATE = 5;
export const SURVEY_REPORT_EMAIL_TEMPLATE = 6;
export const SLA_PLA_INTRODUCTORY_TEMPLATE = 7;
export const SLA_PLA_ONGOING_PLAN_FORMAT_TEMPLATE = 8;
export const ASSESSMENT_INSTRUCTION_TEMPLATE = 9;

export const sortBy = (key) => {
    return (a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0);
};




// WEBPACK FOOTER //
// ./src/config/constants.js